import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const API_KEY = "f7195fc6fb249aa163e95fcd97d2f7b1";
const API_BASE = "https://www.vendus.co.ao/ws/documents";

function VendusDocuments() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const response = await axios.get("http://localhost:5000/api/documents");
      setDocuments(response.data || []);
    } catch (error) {
      console.error("Erro ao carregar documentos:", error);
      alert("Erro ao carregar documentos.");
    }
    setLoading(false);
  };


  





  const downloadPDF = async (documentId) => {
    try {
      const response = await axios.get(`http://localhost:5000/api/documents/${documentId}/pdf`, {
        responseType: 'blob',  // importante para pegar o PDF binário como Blob no navegador
        headers: {
          Authorization: `Bearer ${API_KEY}`, // se backend exigir
        },
      });
  
      // Cria URL temporário para o Blob do PDF
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      window.open(pdfUrl, '_blank');
      
      // Opcional: liberar URL depois de um tempo para evitar leaks de memória
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60 * 1000);
  
    } catch (error) {
      console.error("Erro ao obter o PDF:", error.response?.data || error.message);
      alert("Erro ao obter o PDF da fatura.");
    }
  };
  

  const createFakeDocument = async () => {
    setCreating(true);
    try {
      const payload = {
        register_id: 113682273,
        type: 'FT',
        mode: 'normal',
        stock_operation: 'out',
        date: '2025-05-25',
        date_supply: '2025-05-25',
        output: 'auto',
        client: {
          name: 'Cliente Teste',
          fiscal_id: '500000000',
          address: 'Rua Exemplo, 123',
          email: 'cliente@exemplo.com'
        },
        items: [
          {
            reference: 'demov.3',
            title: 'Pagamento de multa ',
            supply_price: 15.00,
            gross_price: 49.00,
            qty: 1,
            type_id: 'S',
            stock_type: 'M',
            tax_id: 'NOR',
            tax_exemption: 'M00'
          },
          {
            reference: '87474',
            title: 'Pagamento do curso de ingles',
            supply_price: 15000.00,
            gross_price: 12000.00,
            qty: 1,
            type_id: 'P',
            stock_type: 'P',
            tax_id: 'ISE',
            tax_exemption: 'M10'
          },
          {
            reference: 'demov.12',
            title: 'Pagamento de propina mês de propina',
            supply_price: 10.00,
            gross_price: 35.00,
            qty: 1,
            type_id: 'S',
            stock_type: 'M',
            tax_id: 'NOR',
            tax_exemption: 'M00'
          }
        ],
        payments: [
          {
            id: 113682249,
            amount: "12084.00"
          }
        ]
      };

      const response = await axios.post(
        "http://localhost:5000/api/documents",
        payload
      );

      alert(
        "Documento criado com sucesso: " +
          (response.data?.number || response.data?.id || "[sem número]")
      );

      if (typeof fetchDocuments === "function") fetchDocuments();
    } catch (error) {
      console.error("Erro ao criar documento:", error.response?.data || error.message);
      alert("Erro ao criar documento.");
    }
    setCreating(false);
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Lista de Faturas - Vendus API</h2>

      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-primary" onClick={fetchDocuments} disabled={loading}>
          {loading ? "A carregar..." : "Atualizar Lista"}
        </button>
        <button className="btn btn-success" onClick={createFakeDocument} disabled={creating}>
          {creating ? "A criar..." : "Criar Fatura Falsa"}
        </button>
      </div>

      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Número</th>
            <th>Data</th>
            <th>Total Bruto</th>
            <th>Status</th>
            <th>Fatura</th>
          </tr>
        </thead>
        <tbody>
          {documents.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                Nenhuma fatura encontrada.
              </td>
            </tr>
          )}
         {documents.filter(doc => !/^rg/i.test(doc.number)).map(doc => (
            <tr key={doc.id}>
                <td>{doc.id}</td>
                <td>{doc.number}</td>
                <td>{doc.date}</td>
                <td>{doc.amount_gross} Kz</td>
                <td>{doc.status}</td>
                <td>
                  <button  className="btn col-lg-12 btn-sm btn-primary" onClick={() => downloadPDF(doc.id)}>Baixar PDF</button>
                </td>
              </tr>
           ))} 
        </tbody>
      </table>
    </div>
  );
}

export default VendusDocuments;
